export const calcLink = (pathname, customerId, id) => {
  if (pathname === `/customer/${customerId}/sensors` || pathname.match('sensors/location')) {
    return `/customer/${customerId}/sensors${id ? `/location/${id}` : ''}`;
  }
  if (pathname === `/customer/${customerId}` || pathname.match('location')) {
    return `/customer/${customerId}${id ? `/location/${id}` : ''}`;
  }
  if (pathname.match('detached')) {
    return `/customer/${customerId}/detached${id ? `/${id}` : ''}`;
  }
  if (pathname.match('equipments')) {
    return `/customer/${customerId}/equipments${id ? `/${id}` : ''}`;
  }
  if (pathname.match('translates')) {
    return `/customer/${customerId}/translates${id ? `/${id}` : ''}`;
  }
  return pathname;
};
